module.exports = __webpack_public_path__ + "static/media/WEB-pc_29.16f5b1c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/pc/WEB-pc_29.jpg
// module id = 165
// module chunks = 0